import {
  ApiClientError,
  GetPresentationsListResponse,
} from '@raydiant/api-client-js';

import { keys } from '../queryClient';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';

export default function usePresentationsList() {
  return useProtectedQuery<GetPresentationsListResponse, ApiClientError>(
    keys.presentationsList(),
    () => raydiant.getPresentationsList(),
  );
}
